import React from 'react';

interface FormikHelpers {
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
}

export const handleChangePhone = (
    e: React.ChangeEvent<HTMLInputElement>,
    { setFieldValue, name }: { setFieldValue: FormikHelpers['setFieldValue']; name: string }
) => {
    const value = e.target.value;
    // Remove non-numeric characters
    const numericValue = value.replace(/\D/g, '');
    // Format the phone number as XXX-XXXXXX
    if (numericValue.length <= 10) {
        const formattedValue = numericValue.replace(/(\d{3})(\d{0,6})/, '$1-$2');
        setFieldValue(name, formattedValue);
    }
};

export const handleChangeDate = (
    e: React.ChangeEvent<HTMLInputElement>,
    { setFieldValue, name }: { setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void; name: string }
) => {
    const value = e.target.value;

    // Remove non-numeric characters
    const numericValue = value.replace(/\D/g, '');

    // Format the date as YYYY/MM/DD
    let formattedValue = numericValue;

    if (numericValue.length > 8) {
        // Limit to 8 digits (YYYYMMDD)
        formattedValue = numericValue.slice(0, 8);
    }

    if (formattedValue.length <= 4) {
        // Format as YYYY
        formattedValue = formattedValue.replace(/(\d{0,4})/, '$1');
    } else if (formattedValue.length <= 6) {
        // Format as YYYY/MM
        formattedValue = formattedValue.replace(/(\d{4})(\d{0,2})/, '$1/$2');
    } else {
        // Format as YYYY/MM/DD
        formattedValue = formattedValue.replace(/(\d{4})(\d{2})(\d{0,2})/, '$1/$2/$3');
    }

    setFieldValue(name, formattedValue);
};


export const handleNepaliInputChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    { setFieldValue, name }: { setFieldValue: FormikHelpers['setFieldValue']; name: string }
) => {
    const value = e.target.value;
    setFieldValue(name, value);
};

export const handleSelectBox = (
    { setFieldValue, name, value }:
        {
            setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
            name: string;
            value: any;
        }
) => {
    setFieldValue(name, value.value);
};

export const handleDefaultSelectBox = (
    { setFieldValue, name, value }:
        {
            setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
            name: string;
            value: any;
        }
) => {
    setFieldValue(name, value);
};